import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
const antIcon = (
  <LoadingOutlined
    style={{
      fontSize: 80,
    }}
    spin
  />
);
const TableSpinner = () => <Spin indicator={antIcon} />;
export default TableSpinner;